import { Component, OnInit } from '@angular/core';
import { BackendService } from '../shared/backend.service';
import CONFIG from 'src/config';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../shared/auth.service';
import { AlertmessageService } from '../shared/alertmessage.service';
import { NotificationService } from '../notification.service';
import { Router } from '@angular/router';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss'],
  //providers: [NotificationService],
})
export class ApplicationComponent implements OnInit {
  applicationData: FormGroup;
  security: any;
  selectedbenid: any;
  selectedsecid: any;
  Beneficiaries: any;
  securitylist: any;
  Beneficiaries1: any;
  securityrate: any;
  BeneficialOwnerName: any;
  applicationAmount: any;
  objectdata: any[] = [];
  testdata: any;
  MaxAppAmt:  any;


  gridobject: any[] = [];
  finalobject: any = {};
  hide: boolean = false;
  beneficieryList: string[] = [];
  securityidlist: string[] = [];
  amountlist: string[] = [];
  amounttest = new FormControl();
  ben = new FormControl();
  sec = new FormControl();
  Bank: any;
  Branch: any;
  AccountNumber: any;
  RoutingNumber: any;
  InvoiceNumber: any;

  Rate: any;
  rateenable: boolean = false;
  test: boolean = false;

  SelectID = false;
  invoice = false;

  loadingData1: boolean = true;
  removerecord: boolean = false;
  readrecord: boolean = true;
  bendata: any;
  isTermsChecked = false;
  isCheckboxDisabled = false;

  sample1: any
  constructor(
    public _backendservice: BackendService,
    public _formBuilder: FormBuilder,
    public _authService: AuthService,
    public _alert: AlertmessageService,
    public _notification: NotificationService,
    public _router: Router
  ) { }

  ngOnInit(): void {
    this.pageLoad();
    this.setForm();

  }

  pageLoad() {
    this._backendservice.getData(`${CONFIG.applicationApiUrlBase}/${this._authService.NIBNumber}`)
      .subscribe(
        response => {
          //console.log(response);
          this.security = response['security'];
          this.Beneficiaries = response['beneficiaries'];
          this.securitylist = response['securitylist'];
          this.InvoiceNumber = response['invoiceNoIncrement'];
          // console.log(this.security,this.Beneficiaries,this.securitylist);
        })

  }
  SelectionCustomerID(value) {
    // console.log(value);
    this.selectedbenid = value;
    this.SelectID = true;
    // this.Beneficiaries1 = this.Beneficiaries.filter(x => x.customerAccountCode == value.toString());
    // this.BeneficialOwnerName = this.Beneficiaries1[0].beneficialOwnerName;
    // this.Bank = this.Beneficiaries1[0].bank;
    // this.Branch = this.Beneficiaries1[0].branch;
    // this.RoutingNumber = this.Beneficiaries1[0].routingNumber;
    // this.AccountNumber = this.Beneficiaries1[0].accountNumber;

    //// console.log(this.BeneficialOwnerName,this.Bank,this.Branch,this.RoutingNumber,this.AccountNumber );
    //console.log(this.selectedbenid)
    this._backendservice.getData(`${CONFIG.applicationfilterbenApiUrlBase}/${this.selectedbenid}`)
      .subscribe(
        response => {
          //console.log(response); 
          this.bendata = response['beneficiariesdata'];
          // /  console.log(this.bendata); 
          this.BeneficialOwnerName = this.bendata[0].beneficialOwnerName;
          this.Bank = this.bendata[0].bank;
          this.Branch = this.bendata[0].branch;
          this.RoutingNumber = this.bendata[0].routingNumber;
          this.AccountNumber = this.bendata[0].accountNumber;
          //console.log(  this.RoutingNumber)
          let mask = "";

          if (this.AccountNumber) {
            //  console.log(this.AccountNumber.trim().length);
            for (let i = 0; i < this.AccountNumber.trim().length - 4; i++) {
              mask += "*";
            }

            let len = this.AccountNumber.trim().length;
            //console.log(mask + this.AccountNumber.slice(len-4,len));

            this.AccountNumber = mask + this.AccountNumber.trim().slice(len - 4, len);
            // console.log(this.AccountNumber);
            // return mask + this.AccountNumber.slice(3,7)

          }

        })

    //console.log(this.AccountNumber);

  }

  SelectionSecurityID(value) {
    //console.log(value)
    this.selectedsecid = value;
    this._backendservice.getData(`${CONFIG.applicationApiUrlBase}/rate/${value}`)
      .subscribe(
        response => {
           console.log(response); 
          this.Rate = response['rate'];
          this.MaxAppAmt = response['maxAmount']
          console.log(this.MaxAppAmt)
          if (this.Rate != '') {
            //console.log("test")
            this.rateenable = true;
            this.test = true;
          }

        })

  }


  changeAmount(value) {
    if (value !== undefined && value !== null) {
      // here we just remove the commas from value
      this.applicationAmount = value.toString().replace(/,/g, "");
      // console.log(this.applicationAmount)
      var i = this.applicationAmount
      //console.log(i)
      if (i % 100 == 0) {
        //console.log("Test")
        //this._alert.openConfirmationDialo11("Please Enter Amount 1");
      } else {
        this._alert.openConfirmationDialo11(this.amounttest.value + " " + "Not Divisible  by 100 ");
        this.loadingData1 = true;
        return false;
      }


    } else {

      this.applicationAmount = value;
      // console.log(this.applicationAmount)
    }
    //this.amountlist.push(this.applicationAmount);
    //value=null;
    ////console.log( this.applicationAmount);

  }


  // addData(data) {
  //   sessionStorage.clear();

  //   if (data.Beneficiaries == "" || data.Beneficiaries == undefined) {
  //     this._alert.openConfirmationDialogShot("Please select the Beneficiaries");
  //     this.hide = false;
  //     this.rateenable = false;
  //     this.test = true;
  //     return false;
  //   }



  //   this.sample1 = data.SecurityID;
  //   if (data.SecurityID == "" || data.SecurityID == undefined) {
  //     this._alert.openConfirmationDialogShot("Please select the SecurityID");
  //     this.hide = false;
  //     this.rateenable = false;
  //     this.test = true;
  //     return false;
  //   }

  //   if (this.applicationAmount == "" || this.applicationAmount == undefined) {
  //     this._alert.openConfirmationDialogShot("Please Enter the Amount");
  //     this.hide = false;
  //     //  this.rateenable = false;
  //     this.test = true;
  //     return false;
  //   }

  //   data.amount = this.applicationAmount;
  //   data.rateamount = this.Rate;
  //   if (parseInt(data.amount) == 0 || data.amount == "") {
  //     this._alert.openConfirmationDialogShot("Application Amount should be greater than 0");
  //   }
  //   else {

  //     var i = this.applicationAmount
  //     // console.log(i)
  //     if (i % 100 == 0) {
  //       console.log("Test")
  //       //this._alert.openConfirmationDialo11("Please Enter Amount 1");
  //     } else {
  //       this._alert.openConfirmationDialo11(this.amounttest.value + " " + "Not Divisible  by 100 ");
  //       this.loadingData1 = true;
  //       return false;
  //     }
  //     if(i > this.MaxAppAmt){
  //       console.log(i)
  //       console.log(this.MaxAppAmt)
  //       this._alert.openConfirmationDialo11("Amount Entered for " + data.SecurityID + " should be Less than or equal to: " + this.MaxAppAmt.ToString("N0") );
  //     }


  //     this.sample1 = data;
  //     // console.log(this.sample1, data)

  //     this.objectdata.push(data);
  //     this.beneficieryList.push(this.selectedbenid);
  //     this.securityidlist.push(this.selectedsecid);

  //     this.amountlist.push(this.amounttest.value);
  //     this.amounttest = new FormControl();

  //     //console.log(this.selectedbenid);

  //     // console.log(this.selectedsecid);
  //     // for (let i = 0; i <= this.objectdata.length; i++) {
  //     //   console.log("ObjectData")
  //     //   if (this.selectedbenid == this.objectdata[i].Beneficiaries ) {

  //     //     console.log("Without select second record");
  //     //     
  //     //   }}

  //     //console.log(this.objectdata.length)
  //     if (this.objectdata.length > 0) {

  //       this.testdata = this.objectdata;

  //       //console.log(this.testdata, "test");
  //       this.hide = true;
  //       this.rateenable = true;
  //       this.test = false;
  //       //this.invoice = true;

  //     }
  //     else {
  //       // console.log("test1");
  //       this.hide = false;

  //       this.rateenable = false;
  //       this.test = true;
  //       this.invoice = false;
  //     }

  //     this.setForm();

  //   }
  // }


  addData(data) {
    sessionStorage.clear();

    if (data.Beneficiaries == "" || data.Beneficiaries == undefined) {
        this._alert.openConfirmationDialogShot("Please select the Beneficiaries");
        this.hide = false;
        this.rateenable = false;
        this.test = true;
        return false;
    }

    this.sample1 = data.SecurityID;
    if (data.SecurityID == "" || data.SecurityID == undefined) {
        this._alert.openConfirmationDialogShot("Please select the SecurityID");
        this.hide = false;
        this.rateenable = false;
        this.test = true;
        return false;
    }

    if (this.applicationAmount == "" || this.applicationAmount == undefined) {
        this._alert.openConfirmationDialogShot("Please Enter the Amount");
        this.hide = false;
        this.test = true;
        return false;
    }
    

    data.amount = this.applicationAmount;
    data.rateamount = this.Rate;
    let applicationAmount = parseInt(this.applicationAmount.toString().replace(/,/g, ""));
    let maxAppAmt = parseInt(this.MaxAppAmt.toString().replace(/,/g, ""));
    if (parseInt(data.amount) == 0 || data.amount == "") {
        this._alert.openConfirmationDialogShot("Application Amount should be greater than 0");
        return false;
    } else {
      //  var i = this.applicationAmount;

        // Check if amount is divisible by 100
        if (applicationAmount % 100 !== 0) {
            this._alert.openConfirmationDialogShot(this.amounttest.value + " is not divisible by 100.");
            this.loadingData1 = true;
            return false;
        }

        // Check if amount is greater than MaxAppAmt
        if (applicationAmount > maxAppAmt) {
          console.log(maxAppAmt)
          console.log(applicationAmount)
            this._alert.openConfirmationDialogShot(`Amount entered for "${data.SecurityID}"should be less than or equal to:${maxAppAmt.toLocaleString()}`);
            this.loadingData1 = true;
            return false;
        }

        // Proceed with data operations if all conditions are met
        this.sample1 = data;
        this.objectdata.push(data);
        this.beneficieryList.push(this.selectedbenid);
        this.securityidlist.push(this.selectedsecid);
        this.amountlist.push(this.amounttest.value);
        this.amounttest = new FormControl();

        if (this.objectdata.length > 0) {
            this.testdata = this.objectdata;
            this.hide = true;
            this.rateenable = true;
            this.test = false;
        } else {
            this.hide = false;
            this.rateenable = false;
            this.test = true;
            this.invoice = false;
        }

        this.setForm();
    }
}

// TermsAndConditionsForm(){
//   let link = document.createElement("a");
//   if (this.isTermsChecked=true){
//     this._alert.openConfirmationDialogShot("You have read and agreed to the terms and conditions");
//     link.download = "BRS_and_BSB_Disclaimer_Portal";
//     link.href = "assets/img/BRS_and_BSB_Disclaimer_Portal.pdf";
//     link.click();
//   }
//   else{
//     this._alert.openConfirmationDialogShot("Please check the box and Read the terms and conditions");
//   }
  
// }
// TermsAndConditionsForm() {
//   const link = document.createElement("a");
  
//   if (this.isTermsChecked) {
//     this._alert.openConfirmationDialogShot("You have read and agreed to the terms and conditions");
//     link.download = "BRS_and_BSB_Disclaimer_Portal";
//     link.href = "assets/img/BRS_and_BSB_Disclaimer_Portal.pdf";
//     link.click();
//   } else {
   
//     this._alert.openConfirmationDialogShot("Please check the box and read the terms and conditions");
    
//   }
// }

TermsAndConditionsForm(event: MatCheckboxChange) {
  this.isTermsChecked = event.checked; 
  console.log('Checkbox value:', this.isTermsChecked);
  if (this.isTermsChecked) {
    this.isCheckboxDisabled = true; 
    const link = document.createElement("a");
    link.download = "BRS_and_BSB_Disclaimer_Terms_and_Conditions";
   // link.href = "assets/img/BRS_and_BSB_Disclaimer_Portal.pdf";
    link.href = "assets/img/BRS_and_BSB_Disclaimer_Terms_and_Conditions.pdf"
    link.click();
    this._alert.openConfirmationDialogShot("You have read, understood and agree to the Bank's terms and conditions, and acknowledge the Banks Disclaimer");
  } else {
    this._alert.openConfirmationDialogShot("Please check the box and read the terms and conditions");
  }
}




  deleteConfirm(item) {


    for (let i = 0; i <= this.objectdata.length - 1; i++) {
      if (item.Beneficiaries == this.objectdata[i].Beneficiaries && item.SecurityID == this.objectdata[i].SecurityID
        && item.amount == this.objectdata[i].amount) {

        //console.log(i);
        this.objectdata.splice(i, 1);
      }

    }



  }

  SaveData() {
    this.invoice = true;
    //  console.log(this.sample1)
    //     console.log(this.selectedbenid);
    //     console.log(this.beneficieryList)
    //     console.log(this.securityidlist);
    //     console.log(this.objectdata)
    //     console.log(this.objectdata.length)

    this.removesetForm()
    this.Rate = "";
    //  console.log(this.Rate)
    if (this.objectdata.length == 0) {

      this._alert.openConfirmationDialogShot("Select at least one record");
      return;
    }






    var i = this.applicationAmount;
    //console.log(i, this.amountlist)
    if (i % 100 == 0) {
      console.log("Test")
      //this._alert.openConfirmationDialo11("Please Enter Amount 1");
    } else {
      this._alert.openConfirmationDialo11(this.amounttest.value + " " + "Not Divisible  by 100 ");
      this.loadingData1 = true;
      return;
    }

    this.loadingData1 = false;
    //console.log(this.selectedsecid)
    this.beneficieryList.push(this.selectedbenid);
    this.securityidlist.push(this.selectedsecid);

    //    //Amount Validation
    //          if(this.amounttest.value=="" || this.amounttest.value==null){
    //           this.setForm();
    //           this.loadingData1 = true;
    //           //remove Beneficiary list
    //           const index: number = this.beneficieryList.indexOf(this.selectedbenid);
    //           this.beneficieryList.splice(index, 1);

    //          //Remove the securityidlist
    //           const index1: number = this.beneficieryList.indexOf(this.selectedsecid);
    //           this.securityidlist.splice(index1, 1); 

    //           this._alert.openConfirmationDialo11("Please Enter Amount");
    //           return;
    //          }

    // // Beneficiary Validation

    //          if(this.selectedbenid == undefined ){
    //           this.setForm();
    //           this.loadingData1 = true; 

    //         //remove Beneficiary list
    //         const index: number = this.beneficieryList.indexOf(this.selectedbenid);
    //         this.beneficieryList.splice(index, 1);

    //        //Remove the securityidlist
    //         const index1: number = this.beneficieryList.indexOf(this.selectedsecid);
    //         this.securityidlist.splice(index1, 1); 

    //           this._alert.openConfirmationDialo11("Please select the  Beneficiary");
    //           return;
    //          }

    //  // Security ID  Validation

    //          if(this.selectedsecid == undefined ){
    //           this.setForm();
    //           this.loadingData1 = true;

    //              //remove Beneficiary list
    //              const index: number = this.beneficieryList.indexOf(this.selectedbenid);
    //              this.beneficieryList.splice(index, 1);

    //             //Remove the securityidlist
    //              const index1: number = this.beneficieryList.indexOf(this.selectedsecid);
    //              this.securityidlist.splice(index1, 1); 

    //           this._alert.openConfirmationDialo11("Please select the  Security ID");
    //           return;
    //          }




    this.amountlist.push(this.amounttest.value);

    //console.log(this.securityidlist);
    this.amounttest = new FormControl();

    // this.finalobject.beneficieryList=this.beneficieryList;
    // this.finalobject.securityidlist=this.securityidlist;


    this.finalobject.amountlist = this.amountlist;
    this.finalobject.NIBNumber = this._authService.NIBNumber;

    this.finalobject.BeneficialOwnerName = this.BeneficialOwnerName;

    this.finalobject.applicationdata = this.objectdata;
    this.finalobject.InvoiceNumber = this.InvoiceNumber
    //console.log(this.finalobject)

    this._backendservice.postData(this.finalobject, `${CONFIG.applicationApiUrlBase}/save`)
      .subscribe(response => {
        //// console.log(response);
        if (response['result'] == true) {
          this.loadingData1 = true;
          //// console.log("if");
          this._notification.showNotification({ message: response['msg'], type: 'success' });
          this._router.navigate(['/dashboard']);
        }
        else {
          //// console.log("else");
          this.loadingData1 = true;
          this._alert.openConfirmationDialog(response['msg']);
          this._router.navigate(['/dashboard/application']);
        }


      });

  }


  setForm() {
    this.applicationData = this._formBuilder.group({
      //'amount':['',[Validators.required, Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$')]],
      'Beneficiaries': [''],
      'SecurityID': [''],


    })

  }

  removesetForm() {
    this.applicationData = this._formBuilder.group({
      'amount': [''],
      'Beneficiaries': [''],
      'SecurityID': [''],
      'Rate': [''],

    })

  }


}